import classNames from 'classnames';
import styles from './skeleton.module.scss';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
    width?: string | number;
    height?: string | number;
}

export const Skeleton = ({ width, height, ...props }: SkeletonProps) => {
    const { className, ...restProps } = props;
    return (
        <div
            className={classNames([styles.skeleton, className])}
            style={{ width, height }}
            {...restProps}
        />
    );
};
